import React from 'react';
import { StatusPill } from './StatusPill';

export const InfoCard = ({ title, text, active }) => (
  <div
    style={{
      backgroundColor: '#fff',
      padding: '24px',
      borderRadius: '8px',
      border: '1px solid #eaeaea'
    }}
  >
    <div className="d-flex justify-content-between align-items-center">
      <label className='text-dark-50' style={{ fontSize: 13, margin: 0 }}>{title}</label>
      {active !== undefined && <StatusPill active={active} />}
    </div>
    <p style={{ fontSize: 18, fontWeight: 600, margin:  0 }}>{text}</p>
  </div>
);
